import React from 'react';

import Text from '../../../designSystem/Text';
import Header from '../../Header';

import styles from './HelpDeskHeader.module.scss';

import { helpDeskTexts } from '../../../utils/generalTexts';

const HelpDeskHeader = () => {
  return (
    <Header
      rightComponent={
        <Text text={helpDeskTexts.headerTitle} customClass={styles.help_desk_header_title} />
      }
      logoRedirect
      customClass={styles.help_desk_header}
    />
  );
};

export default HelpDeskHeader;
